import { mdiFilterVariant } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Button, Grid, Skeleton, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BilhetePassagem } from 'src/models/LinkPagamento';

import { FiltroTransacoes } from '../../models/FiltroTransacoes.model';
import { FiltroUsuario } from '../../models/FiltroUsuario.model';
import { TIPO_TRANSACAO_PJ_USER, Transacao } from '../../models/Transacao.model';
import FuncionarioService from '../../services/Funcionario.service';
import { Colors } from '../../shared/colors';
import useInfiniteScroll from '../../shared/hooks/infiniteScroll';
import CardTransacao from '../components/CardTransacao';
import DrawerDetalhesViagem from '../features/detalhes-viagem/DrawerDetalhesViagem';
import DrawerFiltrarTransacao from '../features/filtrar-transacoes/DrawerFiltrarTransacaoUsuarios';

const TransacoesUsuarios = () => {
  const navigate = useNavigate();
  const [filtroTransacoes, setFiltroTransacoes] = useState<FiltroUsuario>();

  const [openDrawerFiltroTransacao, setOpenDrawerFiltroTransacao] = useState(false);
  const [bilhetesPassagem, setBilhetespassagem] = useState<BilhetePassagem[] | null>(null);

  const closeDrawerFiltro = (filtroTransacoes: FiltroTransacoes) => {
    setFiltroTransacoes(filtroTransacoes);
    setOpenDrawerFiltroTransacao(false);
  };

  const handleOpenDetalhes = async (transacao: Transacao) => {
    const bilhetes = transacao.bilhetes?.length
      ? transacao.bilhetes
      : await FuncionarioService.obterBilhetesTransacao(transacao.idTransacao);

    setBilhetespassagem(bilhetes);
  };

  const {
    loading,
    hasNext,
    lastElementRef,
    items: transacoes
  } = useInfiniteScroll<Transacao, FiltroUsuario>({
    load: FuncionarioService.listarTransacoes,
    search: filtroTransacoes
  });

  const carregandoItens = (loading && hasNext) || loading;

  return (
    <Grid container paddingY={2}>
      <Grid item xs={12}>
        <Box
          component="header"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
          pb={1.75}
          borderBottom={`1px solid ${Colors.gray2}`}
        >
          <Typography variant="h5" color={Colors.secondary} fontWeight={700}>
            Transações de usuários
          </Typography>
          <Button
            data-tour-pj="employee-filter"
            startIcon={<Icon path={mdiFilterVariant} size={0.75} />}
            onClick={() => setOpenDrawerFiltroTransacao(true)}
            sx={{
              color: Colors.secondary,
              fontSize: 15,
              fontWeight: 500,
              height: 36,
              minWidth: 0,
              px: 1.25,
              textTransform: 'none'
            }}
          >
            Filtrar
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12}>
        {transacoes.map((transacao, index, arr) => {
          const lastElement = arr.length === index + 1;
          const ref = lastElement && hasNext ? lastElementRef : null;
          const card = (
            <CardTransacao
              ref={ref}
              key={transacao.idTransacao}
              walletLayout
              onClick={() => handleOpenDetalhes(transacao)}
              navigateToRecibo={() => navigate(`/recibo-preview/${transacao.idTransacao}`)}
              transacao={transacao}
            />
          );
          return index === 0 ? (
            <div key={transacao.idTransacao} data-tour-pj="employee-transactions">
              {card}
            </div>
          ) : (
            card
          );
        })}
      </Grid>

      <Grid item xs={12}>
        {carregandoItens && (
          <Grid container mt={2} gap={2}>
            {Array(5)
              .fill(1)
              .map((_item, index) => index)
              .map((value) => (
                <Skeleton key={value} variant="rounded" width="100%" height={70} />
              ))}
          </Grid>
        )}
        {!loading && transacoes.length === 0 && (
          <div data-tour-pj="employee-transactions">
            <Typography
              variant="body1"
              fontWeight={500}
              color={Colors.gray1}
              textAlign="center"
              mt={3}
            >
              Não há dados a serem exibidos
            </Typography>
          </div>
        )}
      </Grid>

      <DrawerFiltrarTransacao
        tipoTransacoes={TIPO_TRANSACAO_PJ_USER}
        open={openDrawerFiltroTransacao}
        onClose={closeDrawerFiltro}
        onCancel={() => setOpenDrawerFiltroTransacao(false)}
        permitirFiltrarUsuarios
        tab={3}
      />

      <DrawerDetalhesViagem bilhetes={bilhetesPassagem} onClose={() => setBilhetespassagem(null)} />
    </Grid>
  );
};

export default TransacoesUsuarios;
